import { useNavigate } from "react-router-dom";
import { FiUserCheck, FiUserX } from "react-icons/fi";
import {
  formateDateToJalali,
  typePersianConverter,
} from "../../../utils/Functions";
import Table from "../../common/table";

const ProfileRecordsList = ({
  data,
  user_record,
  recordsPage,
  setRecordsPage,
}: any) => {
  const navigate = useNavigate();
  const pageSize = Math.round(data?.count / 10);

  const PaginationBtn = ({ number, isActive }: any) => {
    return (
      <button
        onClick={() => setRecordsPage(number)}
        className={`join-item btn btn-md shadow-none border-[1px] border-gray-100 hover:border-gray-100 hover:bg-gray-200 ${
          isActive ? "bg-gray-200" : "bg-white"
        }`}
      >
        {number}
      </button>
    );
  };

  const owner = (ownerData: any) => {
    return ownerData.is_for_other ? "temp_user" : "creator";
  };

  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  return (
    <>
      <div className="overflow-x-auto mt-10 border rounded-xl">
        <Table
          header={[
            "",
            "آزمایش‌دهنده",
            "تاریخ ایجاد آزمایش ",
            "فاکتورها",
            "فایل‌ها",
          ]}
          body={data?.results?.map((record: any, idx: number) => (
            <tr
              className="cursor-pointer hover duration-300 border-gray-100"
              key={idx}
              onClick={() =>
                navigate(`/dashboard-records/${user_record}/${record.id}`)
              }
            >
              <th>{idx + 1}</th>
              <TdComponent>
                <div className="flex items-center">
                  {record.is_for_other ? (
                    <FiUserX size={16} className="ml-2 text-pr_blue_dark" />
                  ) : (
                    <FiUserCheck
                      size={16}
                      className="ml-2 text-pr_green_dark"
                    />
                  )}
                  {
                    //@ts-ignore
                    `${record[owner(record)].first_name} ${
                      //@ts-ignore
                      record[owner(record)].last_name
                    }`
                  }
                </div>
              </TdComponent>
              <TdComponent>
                {formateDateToJalali(record.created_at)}
              </TdComponent>
              <TdComponent>{record.components_result.length}</TdComponent>
              <TdComponent>{record.files.length}</TdComponent>
            </tr>
          ))}
        />
      </div>
      {data?.count > 10 && (
        <div className="join flex justify-center mt-10">
          {Array.from({ length: pageSize }, (_, index) => (
            <PaginationBtn
              number={index + 1}
              isActive={recordsPage === index + 1}
              key={index}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default ProfileRecordsList;
